import React, { useState } from 'react';
import { 
  FileText, 
  RefreshCw, 
  Scale, 
  ChevronRight,
  ArrowLeft,
  Truck,
  Lock,
  Mail,
  Shield
} from 'lucide-react';
import TermsAndConditions from './TermsAndConditions';
import RefundPolicy from './RefundPolicy';
import PrivacyPolicy from './PrivacyPolicy';
import ContactUs from './ContactUs';
import ShippingDelivery from './ShippingDelivery';

const Legal = () => {
  const [activeSection, setActiveSection] = useState('main'); // 'main', 'terms', 'refund', 'privacy', 'contact', 'shipping'

  const renderContent = () => {
    switch (activeSection) {
      case 'terms':
        return <TermsAndConditions />;
      case 'refund':
        return <RefundPolicy />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'contact':
        return <ContactUs />;
      case 'shipping':
        return <ShippingDelivery />;
      default:
        return (
          <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h1 style={{ fontSize: '2rem', color: '#fff', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Scale size={32} />
                Legal Information
              </h1>
              <p style={{ color: '#a5a6ad', fontSize: '1rem' }}>
                Important legal documents and policies governing your use of CommunityofHubs
              </p>
            </div>

            {/* Legal Cards Grid */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: '1.5rem',
              marginBottom: '2rem'
            }}>
              {/* Terms and Conditions Card */}
              <div 
                onClick={() => setActiveSection('terms')}
                style={{
                  background: '#111113',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #222326'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3a3a40';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#222326';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    background: 'rgba(59, 130, 246, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FileText size={24} color="#3b82f6" />
                  </div>
                  <ChevronRight size={20} color="#a5a6ad" style={{ marginLeft: 'auto' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#fff' }}>
                  Terms and Conditions
                </h3>
                <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.5' }}>
                  Read our Terms and Conditions to understand the rules, guidelines, and legal agreements for using CommunityofHubs platform.
                </p>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(59, 130, 246, 0.1)', 
                    borderRadius: '20px',
                    color: '#3b82f6'
                  }}>
                    User Agreement
                  </span>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(59, 130, 246, 0.1)', 
                    borderRadius: '20px',
                    color: '#3b82f6'
                  }}>
                    Privacy
                  </span>
                </div>
              </div>

              {/* Privacy Policy Card */}
              <div 
                onClick={() => setActiveSection('privacy')}
                style={{
                  background: '#111113',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #222326'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3a3a40';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#222326';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    background: 'rgba(139, 92, 246, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Lock size={24} color="#8b5cf6" />
                  </div>
                  <ChevronRight size={20} color="#a5a6ad" style={{ marginLeft: 'auto' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#fff' }}>
                  Privacy Policy
                </h3>
                <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.5' }}>
                  Learn how we collect, use, and protect your personal information in accordance with privacy laws.
                </p>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(139, 92, 246, 0.1)', 
                    borderRadius: '20px',
                    color: '#8b5cf6'
                  }}>
                    Data Protection
                  </span>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(139, 92, 246, 0.1)', 
                    borderRadius: '20px',
                    color: '#8b5cf6'
                  }}>
                    GDPR
                  </span>
                </div>
              </div>

              {/* Refund Policy Card */}
              <div 
                onClick={() => setActiveSection('refund')}
                style={{
                  background: '#111113',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #222326'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3a3a40';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#222326';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    background: 'rgba(16, 185, 129, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <RefreshCw size={24} color="#10b981" />
                  </div>
                  <ChevronRight size={20} color="#a5a6ad" style={{ marginLeft: 'auto' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#fff' }}>
                  Refund Policy
                </h3>
                <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.5' }}>
                  Learn about our refund policy, cancellation terms, and money-back guarantee conditions.
                </p>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(16, 185, 129, 0.1)', 
                    borderRadius: '20px',
                    color: '#10b981'
                  }}>
                    Refunds
                  </span>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(16, 185, 129, 0.1)', 
                    borderRadius: '20px',
                    color: '#10b981'
                  }}>
                    Cancellation
                  </span>
                </div>
              </div>

              {/* Shipping Delivery Card */}
              <div 
                onClick={() => setActiveSection('shipping')}
                style={{
                  background: '#111113',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #222326'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3a3a40';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#222326';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    background: 'rgba(245, 158, 11, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Truck size={24} color="#f59e0b" />
                  </div>
                  <ChevronRight size={20} color="#a5a6ad" style={{ marginLeft: 'auto' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#fff' }}>
                  Shipping & Delivery
                </h3>
                <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.5' }}>
                  Understand our shipping methods, delivery timelines, and associated policies.
                </p>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(245, 158, 11, 0.1)', 
                    borderRadius: '20px',
                    color: '#f59e0b'
                  }}>
                    Delivery
                  </span>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(245, 158, 11, 0.1)', 
                    borderRadius: '20px',
                    color: '#f59e0b'
                  }}>
                    Shipping
                  </span>
                </div>
              </div>

              {/* Contact Us Card */}
              <div 
                onClick={() => setActiveSection('contact')}
                style={{
                  background: '#111113',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #222326'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#3a3a40';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#222326';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    background: 'rgba(236, 72, 153, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Mail size={24} color="#ec4899" />
                  </div>
                  <ChevronRight size={20} color="#a5a6ad" style={{ marginLeft: 'auto' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#fff' }}>
                  Contact Us
                </h3>
                <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.5' }}>
                  Get in touch with our support team for any questions, concerns, or assistance.
                </p>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(236, 72, 153, 0.1)', 
                    borderRadius: '20px',
                    color: '#ec4899'
                  }}>
                    Support
                  </span>
                  <span style={{ 
                    fontSize: '0.75rem', 
                    padding: '0.25rem 0.75rem', 
                    background: 'rgba(236, 72, 153, 0.1)', 
                    borderRadius: '20px',
                    color: '#ec4899'
                  }}>
                    Help Center
                  </span>
                </div>
              </div>
            </div>

            {/* Additional Legal Info */}
            <div style={{
              background: '#111113',
              borderRadius: '1rem',
              padding: '1.5rem',
              border: '1px solid #222326',
              marginTop: '1rem'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                <Shield size={20} color="#10b981" />
                <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#fff' }}>
                  Important Legal Notice
                </h3>
              </div>
              <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
                By using CommunityofHubs, you acknowledge that you have read, understood, and agree to be bound by our Terms and Conditions, Privacy Policy, and Refund Policy.
              </p>
              <p style={{ color: '#a5a6ad', fontSize: '0.875rem', lineHeight: '1.6' }}>
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        );
    }
  };

  const getSectionTitle = () => {
    switch (activeSection) {
      case 'terms': return 'Terms and Conditions';
      case 'refund': return 'Refund Policy';
      case 'privacy': return 'Privacy Policy';
      case 'contact': return 'Contact Us';
      case 'shipping': return 'Shipping & Delivery';
      default: return '';
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#0f0f10',
      color: '#fff',
      position: 'relative'
    }}>
      {activeSection !== 'main' && (
        <div style={{
          position: 'sticky',
          top: 0,
          background: '#0f0f10',
          borderBottom: '1px solid #222326',
          padding: '1rem 2rem',
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => setActiveSection('main')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'transparent',
              border: 'none',
              color: '#a5a6ad',
              cursor: 'pointer',
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
              transition: 'all 0.2s ease',
              fontSize: '0.875rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#1a1a1c';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#a5a6ad';
            }}
          >
            <ArrowLeft size={18} />
            Back to Legal Overview
          </button>
          <div style={{ 
            height: '24px', 
            width: '1px', 
            background: '#222326' 
          }} />
          <span style={{ color: '#fff', fontWeight: 500 }}>
            {getSectionTitle()}
          </span>
        </div>
      )}
      
      {renderContent()}
    </div>
  );
};

export default Legal;